import { render, staticRenderFns } from "./team-list.vue?vue&type=template&id=f52a5524&"
import script from "./team-list.vue?vue&type=script&lang=js&"
export * from "./team-list.vue?vue&type=script&lang=js&"
import style0 from "./team-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports